import React from 'react';
import { prop } from 'ramda';

import { Link } from '@core/js/components/common/Link';

import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';

import style from './MyAccount.scss';

export const MyAccount: React.FC = () => {
    const translate = useComponentTranslations();
    const userDetails = useUserSelector(prop('userDetails'));
    const accountPage = useAppSelector(prop('accountPage'));

    return (
        <Link
            href={accountPage}
            className={style.account}
            aria-label={translate('header.account.aria-label')}
        >
            <span className={style.welcome}>
                <span className={style.welcomeMessage}>
                    {translate('welcomeTitle')}
                    <span>{', '}</span>
                </span>
                <span className={style.loginName}>{userDetails?.loginName}</span>
            </span>
        </Link>
    );
};
